export default (doc, stringHeader, obj, arrayString) => {
      var header = [stringHeader, ""];
      var values = Object.values(obj);
      var body = arrayString.map((value, index) => [value, values[index]]);
    doc.autoTable({
        head: [header],
        body: body
      });
}